/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { DeleteDraftApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteDraft: build.mutation<unknown, DeleteDraftApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/v1/quick-draft/${queryArg.id}`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as deleteDraftApi };
export const { useDeleteDraftMutation } = injectedRtkApi;
